// src/components/pages/transfer/TransfersList.js
import React from 'react';
import { Table, Tag, Space } from 'antd';
import { STATUS_COLORS } from '../../constants';
import dayjs from 'dayjs';



const TransfersList = ({ transfers, onSelectTransfer }) => {
    const columns = [
        {
            title: 'Transfer #',
            dataIndex: 'transfer_number',
            key: 'transfer_number',
            render: (text, record) => (
                <a onClick={() => onSelectTransfer(record.id)}>{text}</a>
            ),
        },
        {
            title: 'From',
            dataIndex: ['source_shop', 'name'],
            key: 'source_shop',
        },
        {
            title: 'To',
            dataIndex: ['target_shop', 'name'],
            key: 'target_shop',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: status => (
                <Tag color={STATUS_COLORS[status]}>
                    {status.toUpperCase()}
                </Tag>
            ),
        },

        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm'),
        }
    ];

    return (
        <Table
            columns={columns}
            dataSource={transfers}
            rowKey="id"
            pagination={{ pageSize: 50 }}
            scroll={{ x: 'max-content' }}
            style={{ maxWidth: '100%' }}
        />
    );
};

export default TransfersList;